export default "__VITE_ASSET__CV8p74Hj__"